import React, { useRef } from "react"
import { Container, Row } from "reactstrap"
import classnames from "classnames"
import { prop } from "ramda"
import { useChain, useTransition, animated } from "react-spring"

export default ({
  anchor,
  children,
  className,
  dotColor = "yellow",
  data: { title, content },
}) => {
  const initialInternalStyle = {
    opacity: 0,
    transform: "translate3d(0,40px,0)",
  }
  const transitionedInternalStyle = {
    opacity: 1,
    transform: "translate3d(0,0px,0)",
  }

  const baseRow = (
    <Row className="align-items-center text-center py-3 py-sm-4 py-md-5">
      <div className="mb-3 mb-sm-4 mx-auto">
        <h3 className={`m-0 dot dot-${dotColor}`}>{title}</h3>
      </div>
      <div className="col-md-10 offset-md-1">
        <p>{content}</p>
      </div>
    </Row>
  )

  const transitionedContent = children ? [baseRow, children] : [baseRow]
  const transitionedContentWithKeys = transitionedContent.map((element, i) => ({
    ...element,
    key: i,
  }))

  const internalTransitionsRef = useRef()
  const internalTransitions = useTransition(
    transitionedContentWithKeys,
    prop("key"),
    {
      ref: internalTransitionsRef,
      trail: 400 / transitionedContentWithKeys.length,
      from: initialInternalStyle,
      enter: transitionedInternalStyle,
      leave: initialInternalStyle,
    }
  )

  const section = (
    <section id={anchor} className={classnames("py-4 py-sm-5", className)}>
      <Container className="py-4 py-sm-5">
        {internalTransitions.map(({ item, props, key }) => (
          <animated.div key={key} style={props} {...item.props}></animated.div>
        ))}
      </Container>
    </section>
  )

  const initialSectionStyle = {
    opacity: 0,
  }
  const transitionedSectionStyle = {
    opacity: 1,
  }

  const sectionTransitionsRef = useRef()
  const sectionTransition = useTransition(section, prop("key"), {
    ref: sectionTransitionsRef,
    from: initialSectionStyle,
    enter: transitionedSectionStyle,
    leave: initialSectionStyle,
  })

  useChain([sectionTransitionsRef, internalTransitionsRef], [0, 0.25])

  return sectionTransition.map(({ item, props, key }) => (
    <animated.section
      key={key}
      style={props}
      {...item.props}
    ></animated.section>
  ))
}
